import {computed} from "vue";
import {useMutation, useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast, successToast, warningToast} from "@/composables/useToasts";

export const useSeoScore = () => {
  const query = useQuery({
    queryKey: ['seo-score'],
    queryFn: async () => {
      const {data} = await axios.get('/ajax/v2/website/seo-score');

      return data.data;
    },
  });

  const seoScoreData = computed(() => query.data.value);
  const optimisationScore = computed(() => seoScoreData.value?.optimisation_score ?? 0);
  const visibilityScoreStats = computed(() => seoScoreData.value?.visibility_score_stats ?? {});
  const stats = computed(() => seoScoreData.value?.stats ?? []);
  const visibilityScore = computed(() => seoScoreData.value?.visibility_score_stats.score ?? 0);

  return {
    ...query,
    seoScoreData,
    optimisationScore,
    visibilityScoreStats,
    visibilityScore,
    stats,
  };
};

const refreshScore = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => axios.get('/ajax/v2/website/seo-score/generate'),
    onSuccess: async () => {
      successToast('Website visibility score successfully refreshed.');

      await queryClient.refetchQueries({ queryKey: ['seo-score'] });

      window.mixpanel('SEO Score: Refreshed Score');
    },
    onError: (error) => {
      if (error.response.status === 403) {
        warningToast('You\'re reached your daily refresh limit. Please try again tomorrow.');
        return;
      }

      errorToast('Something went wrong, please try again.');
    },
  });
};

export {
  refreshScore,
};
